module.exports = __webpack_public_path__ + "media/illustrations/share-profile-89ed2be5.svg";